import axios from 'axios';
import { osName, osVersion } from 'react-device-detect';
import { put, select } from 'redux-saga/effects';
import appJson from '../../package.json';
import * as actions from 'store/actions';

const getAuthState = (state) => state.auth;
const getAppState = (state) => state.app;

export function* apiPost(apiCall, data) {
  // const state = store.getState();
  const auth = yield select(getAuthState);
  const app = yield select(getAppState);

  const sessionToken = yield auth.sessionToken
    ? auth.sessionToken
    : localStorage.getItem('sessionToken')
    ? localStorage.getItem('sessionToken')
    : 'NULL';
  const url = yield app.selectedServer ? `${app.selectedServer.URL + apiCall}/${sessionToken}` : `${app.defaultServer + apiCall}/${sessionToken}`;
  const newData = data;
  newData.os = osName;
  newData.osver = osVersion;
  newData.appver = appJson.version;
  newData.AppKey = 'desktop';
  try {
    // eslint-disable-next-line global-require
    const qs = yield require('qs');
    const response = yield axios.post(url, qs.stringify(newData));
    if (app.debugMode) {
      // console.log("data", newData);
      if (response.error_message) console.log('There is an error_message!: '.response.data.error_message);
      console.log('apiCall: ', apiCall);
      console.log('apiGet - response:', response);
    }
    return response;
  } catch (error) {
    console.log('apiCall: ', apiCall);
    if (error.response.data) console.log('apiPost - error.response.data: ', error.response.data);
    if (error.response.data.auto_logout && sessionToken) {
      if (sessionToken) yield put(actions.logout(true));
    } else if (error.response.data.error_code === 20) {
      yield put(actions.accountNeedsVerification('Email'));
    } else if (error.response.data.error_code === 21) {
      yield put(actions.accountNeedsVerification('Phone'));
      // errors with code 10 errors are thrown when user needs to verify their account.
      // In these cases, rather than logging an app error, we'll send them to /verify
    } else if (error.response && error.response.data && error.response.data.error_message && error.response.data.error_code !== 10) {
      yield put(actions.logAppError(error.response.data.app_error_title, error.response.data.error_message));
    }
    throw error;
  }
}

export function* apiImageUpload(apiCall, data) {
  const auth = yield select(getAuthState);
  const app = yield select(getAppState);
  const sessionToken = yield auth.sessionToken;
  const url = yield app.selectedServer ? `${app.selectedServer.URL + apiCall}/${sessionToken}` : `${app.defaultServer + apiCall}/${sessionToken}`;
  const newData = data;
  newData.os = osName;
  newData.osver = osVersion;
  newData.appver = appJson.version;
  newData.AppKey = 'desktop';
  try {
    const response = yield axios({
      method: 'post',
      url,
      data: newData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } },
    });
    if (app.debugMode) console.log('apiGet - response:', response);
    return response;
  } catch (error) {
    console.log('url: ', url);
    if (error.response.data) console.log('apiPost - error.response.data: ', error.response.data);
    if (error.response.data.auto_logout && sessionToken) {
      console.log('error.response.data.auto_logout && sessionToken - about to log out');
      yield put(actions.logout(true));
    } else if (
      error.response &&
      error.response.data &&
      error.response.data.error_message &&
      !error.response.data.error_message.includes('nvalid session')
    ) {
      yield put(actions.logAppError(error.response.data.app_error_title, error.response.data.error_message));
    }
    throw error;
  }
}
